var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Grunddaten")]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Position",
              "options-loader": _vm.loadCostUnitCodeOptions,
              property: "costUnitCode",
              required: true,
              type: "autocomplete",
            },
            on: { change: _vm.handleCostUnitCodeChange },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "auto-select-single-option": true,
              dependencies: ["costUnitCode"],
              "form-context": _vm.formContext,
              label: "Quelle",
              "options-loader": _vm.loadSourceOptions,
              property: "source",
              required: true,
              type: "autocomplete",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Beziffert am",
              property: "dateReceipt",
              required: true,
              type: "datepicker",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              "is-loading-from-parent": _vm.isLoadingHideSettings > 0,
              label: "Nicht anzeigen für",
              "mandatory-hide-for-group": _vm.mandatoryHideGroups,
              options: _vm.hideForGroupOptions,
              property: "hide",
              "record-id": _vm.recordId,
              required: true,
              type: "hideForGroup",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.showCustomFields
            ? _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Beschreibung Position",
                  property: "costUnitText",
                  type: "text",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Beleg Nr.",
              property: "receipt",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "auto-select-single-option": true,
              "default-value": _vm.formContext.data.defaultInsuranceFigure,
              dependencies: ["costUnitCode"],
              "form-context": _vm.formContext,
              label: "Bezifferungsart",
              "options-loader": _vm.loadInsuranceFigureOptions,
              property: "insuranceFigure",
              required: true,
              type: "autocomplete",
            },
          }),
          _vm._v(" "),
          _vm.showAssessmentField
            ? _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "GA erstellt am",
                  property: "dateAssessmentCreated",
                  type: "datepicker",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showRentVehicleFields
        ? _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  dependencies: ["costUnitCode"],
                  "form-context": _vm.formContext,
                  label: "Schwacke Kl. d. Mietwagens",
                  "options-loader": _vm.loadVehicleRentClassOptions,
                  property: "carRentalVehicleRentClass",
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Anzahl Miettage lt. Rechnung",
                  property: "carRentalRefundedRentDays",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Anzahl Miettage lt. Versicherung",
                  property: "carRentDaysInsurance",
                  type: "text",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-9",
            attrs: {
              "form-context": _vm.formContext,
              label: "Bemerkung",
              property: "paymentComment",
              type: "textarea",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.formContext.permissions.canIndexSubtotals === true
        ? _c("csp-record-detail-cost-unit-workshop-invoice-positions", {
            attrs: { "form-context": _vm.formContext },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h2", [_vm._v("Betrag")]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showCopaymentField,
                expression: "showCopaymentField",
              },
            ],
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Selbstbeteiligung",
              property: "amountCopayment",
              type: "currency",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Automatische Berechnung",
              property: "autoCalc",
              type: "radio",
            },
          }),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "3" } }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              disabled: true,
              "form-context": _vm.formContext,
              label: "Akzeptierte Minderung (netto)",
              property: "amountAdjustmentNet",
              type: "currency",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              disabled: true,
              "form-context": _vm.formContext,
              label: "Akzeptierte Minderung (brutto)",
              property: "amountAdjustmentGross",
              type: "currency",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Nettobetrag",
              property: "amountNet",
              required: true,
              type: "currency",
            },
            on: { change: _vm.recalculateFromNet },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Bruttobetrag",
              property: "amount",
              required: true,
              type: "currency",
            },
            on: { change: _vm.recalculateFromGross },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "auto-select-single-option": true,
              dependencies: ["costUnitCode"],
              "form-context": _vm.formContext,
              label: "USt.",
              "options-loader": _vm.loadVatRateOptions,
              property: "vatRate",
              required: true,
              type: "autocomplete",
            },
            on: { change: _vm.recalculateFromVatPercent },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "USt.-Betrag",
              property: "amountVat",
              required: true,
              type: "currency",
            },
            on: { change: _vm.recalculateAmountVat },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }